<ui-slider [navigation]="true" [spaceBetween]="24">
  @for (i of skeletonArray; track $index) {
    <ui-product-card-skeleton uiSliderSlide></ui-product-card-skeleton>
  }
</ui-slider>
